const fonts = {
  avenirNextDemi: 'avenir-next-demi, system, sans-serif',
  avenirNextMedium: 'avenir-next-medium, system, sans-serif',
  avenirNextRegular: 'avenir-next-regular, system, sans-serif',
  avenirNextBold: 'avenir-next-bold, system, sans-serif',
  avenirNextHeavy: 'avenir-next-heavy, system, sans-serif',
  avenirNextThin: 'avenir-next-thin, system, sans-serif'
}

export default fonts
